import React, { useRef } from 'react';
import { CommandBarButton, mergeStyles } from 'office-ui-fabric-react';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FileUploader(_ref) {
  let {
    acceptedFormats = [],
    onFileUpload = () => {},
    testId
  } = _ref;
  const inputElement = useRef(null);
  const inputStyles = mergeStyles({
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%'
  });
  const openFilePicker = () => inputElement.current && inputElement.current.click();
  return /*#__PURE__*/_jsxs(Stack, {
    styles: {
      root: {
        position: 'relative',
        width: 90,
        height: '100%'
      }
    },
    children: [/*#__PURE__*/_jsx("input", {
      ref: inputElement,
      type: "file",
      accept: acceptedFormats.toString(),
      className: inputStyles,
      onChange: e => onFileUpload(e.target.files || undefined),
      "data-id": testId
    }), /*#__PURE__*/_jsx(CommandBarButton, {
      styles: {
        root: {
          width: '100%',
          height: '100%',
          cursor: 'pointer'
        }
      },
      iconProps: {
        iconName: 'Upload'
      },
      onClick: openFilePicker,
      children: "Upload"
    })]
  });
}